import { Typography } from "@mui/material";
import { SessionDetailPanel } from "./SessionDetailPanel";
import { NoteDetailPanel } from "./NoteDetailPanel";
import { PrescriptionDetailPanel } from "./PrescriptionDetailPanel";
import { OrderDetailPanel } from "./OrderDetailPanel";
import { TaskDetailPanel } from "./TaskDetailPanel";
import { CustomerSurveyDetailPanel } from "./CustomerSurveyDetailPanel";
import type { LogbookEntry } from "../../types";

type LogbookDetailPanelProps = {
	selectedItem: LogbookEntry | null;
	treatmentId: string | number;
};

export const LogbookDetailPanel = ({ selectedItem, treatmentId }: LogbookDetailPanelProps) => {
	if (selectedItem?.type === "session") {
		return <SessionDetailPanel session={selectedItem.session} notes={selectedItem.notes} treatmentId={treatmentId} />;
	}
	if (selectedItem?.type === "note") {
		return <NoteDetailPanel note={selectedItem.note} treatmentId={treatmentId} />;
	}
	if (selectedItem?.type === "prescription") {
		return <PrescriptionDetailPanel prescription={selectedItem.prescription} />;
	}
	if (selectedItem?.type === "order") {
		return <OrderDetailPanel order={selectedItem.order} orderSubtype={selectedItem.orderSubtype} />;
	}
	if (selectedItem?.type === "task") {
		return <TaskDetailPanel task={selectedItem.task} treatmentId={treatmentId} />;
	}
	if (selectedItem?.type === "customer_survey") {
		return <CustomerSurveyDetailPanel customerSurvey={selectedItem.customerSurvey} />;
	}
	return (
		<Typography color="text.secondary" sx={{ mt: 4, textAlign: "center" }}>
			Selecione uma sessão ou nota para ver detalhes.
		</Typography>
	);
};
